import * as Mahjong from "@ravalmatic/mahjong-engine";

export interface GameData {
    muted: boolean;     // se usa para el soundtrack
    firstSession: boolean;
    categoriesData: { [category: string]: { n: number, levelsData: {id: string, highScore: number, time: number}[] } };
    savedState?: Mahjong.BoardData;
    data: {
        fxMuted: boolean;
        language: string;
        savedActions: Mahjong.Action[];
    };
}

export interface Day {
    day: number;
    month: number;
    year: number;
}

export interface Board {
    id: number;
    name: string;
    cat: string;
    map: any;
}

export enum BoardState {
    LOCKED,
    UNLOCKED,
    SOLVED
}

export enum Category {
    PLANTS = "Plants",
    BUILDINGS = "Buildings",
    PYRAMIDS = "Pyramids",
    ANIMALS = "Animals",
    SYMBOLS = "Symbols",
    ZODIAC = "Zodiac",
    LETTERS = "Letters",
    CLASSIC = "Classic",
    THINGS = "Things",
    FORMS = "Forms"
}

export enum Language {
    EN = "en",
    ES = "es",
    CA = "ca",
    DE = "de",
    FR = "fr",
    IT = "it",
    PT = "pt",
    NL = "nl",
    RU = "ru",
    JA = "ja"
}
